import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule, BrowserXhr } from '@angular/http';
import { AdminLayoutService } from './layouts/admin/admin-layout.service';
import { NgProgressModule, NgProgressBrowserXhr } from 'ngx-progressbar';
import { HttpClient } from './services/http.service';
import { AppConstants } from './app.constants';
import { AppRoutes } from './app.routing';
import { GrowlModule } from 'primeng/primeng';
import {Ng2Webstorage,LocalStorageService} from 'ng2-webstorage';
import { AppComponent } from './app.component';
import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { SharedModule } from './shared/shared.module';
import { BreadcrumbsComponent } from './layouts/admin/breadcrumbs/breadcrumbs.component';
import { TitleComponent } from './layouts/admin/title/title.component';
import { ScrollModule } from './scroll/scroll.module';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { AddUserFirebaseService } from './components/manageuser/adduser/adduserfirebase.service';
import { MessageService } from 'primeng/components/common/messageservice';
import { NoticeboardService } from './components/noticeboard/noticeboard/noticeboard.service';
import { DataAnalyticsService } from './components/dataAnalytics/dataAnalytics.service';
import { PaginationModule } from 'ngx-bootstrap';
import { AngularFireModule } from 'angularfire2';
import {AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable} from 'angularfire2/database-deprecated';
import * as firebase from "firebase";
import {AppService} from './app.service';
import{PrimeNgModule} from './shared/primeng/primengmodule';
import { MaterialModule } from './shared/material-design/material-module';
import { ParentComponent } from './parent/parent.component';
import { ParentModule } from './parent/parent.module';

import { CourseHService } from './parent/dashboard/pages/course/courseH.service';

import { ParentChildService } from './parent/dashboard/pages/parentchild/parentchild-advanceQ.service';
import { Daterangepicker } from 'ng2-daterangepicker';

export const firebaseConfig= {
  apiKey: "AIzaSyAOz7H73bHtm9Bvtb1iNBQKIF-t8l6Asj4",
  authDomain: "project-3333275275859062414.firebaseapp.com",
  databaseURL: "https://project-3333275275859062414.firebaseio.com",
  projectId: "project-3333275275859062414",
  storageBucket: "project-3333275275859062414.appspot.com",
  messagingSenderId: "1045603562391"
};
firebase.initializeApp(firebaseConfig);
@NgModule({
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    AuthLayoutComponent,
    BreadcrumbsComponent,
    TitleComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    RouterModule.forRoot(AppRoutes,{ useHash: true }),
    PaginationModule.forRoot(),
    FormsModule,
    HttpModule,
    NgProgressModule,
    ScrollModule,
    GrowlModule,
    Ng2Webstorage,
    PrimeNgModule,
    ParentModule,
    AngularFireModule.initializeApp(firebaseConfig),
    MaterialModule,
    Daterangepicker
    ],

  exports: [ScrollModule],
  providers: [
    { provide: BrowserXhr, useClass: NgProgressBrowserXhr },
    HttpClient, AppConstants, NoticeboardService, DataAnalyticsService, MessageService,AngularFireDatabase,
    LocalStorageService,AppService,AddUserFirebaseService, AdminLayoutService,CourseHService,ParentChildService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/app.module.ts